import { sub } from "date-fns"; // date-fns for date manipulation
import RssFeedIcon from "@mui/icons-material/RssFeed";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import TagIcon from "@mui/icons-material/Tag";

export const newsTypes = [
  {
    icon: NewspaperIcon,
    name: "breakingnews",
  },
  {
    icon: TagIcon,
    name: "socialsearcher",
  },
  {
    icon: RssFeedIcon,
    name: "rssfeeds",
  },
];

export const filters = [
  {
    name: "Last 24 hours",
    value: "24h",
    func: sub(new Date(), { hours: 24 }),
  },
  {
    name: "Last 72 hours",
    value: "72h",
    func: sub(new Date(), { hours: 72 }),
  },
  {
    name: "Last week",
    value: "1w",
    func: sub(new Date(), { weeks: 1 }),
  },
  {
    name: "Last month",
    value: "1m",
    func: sub(new Date(), { months: 1 }),
  },
];
